import { ShieldAlert } from "lucide-react";

export const DisclosureBanner = ({ compact = false }) => (
  <div
    data-testid="disclosure-banner"
    className={`rounded-lg border border-border bg-card px-4 ${compact ? "py-2.5" : "py-3"} text-sm text-muted-foreground flex items-start gap-3`}
  >
    <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0 text-[hsl(var(--status-mismatch))]" aria-hidden="true" />
    <p className="leading-relaxed">
      <span className="font-medium text-foreground">Service disclosure: </span>
      GetYourQSIP is a private membership association providing a document information and report-request
      service for educational and research purposes only. We do{" "}
      <span className="font-semibold text-foreground">not</span> issue official CUSIP® identifiers and are{" "}
      <span className="font-semibold text-foreground">not</span> affiliated with CUSIP Global Services. This is
      not legal advice.
    </p>
  </div>
);
